













































































































































import Vue from 'vue'
export default Vue.extend({
  props: ['detailDialog', 'data'],
  data() {
    return {
    }
  },
  methods: {
    closeDetailDialog() {
      this.$emit('closeDialog')
    },
    getStatusRequestDestination(item, destination) {
      for (const app of item.temp_data.temp_apps) {
        if (app.requested_destination_local_ids.includes(destination.local_id) && item.status.toLowerCase() === 'approved') {
          return "Granted";
        }
      }
      return "Not granted";
    },
  }
})
